import type { Except } from '@festina-life/core'

import { IconButton } from '../../actions/iconButton/IconButton'
import { useTranslate } from '../../hooks/useTranslate'
import { Dropdown } from '../../structure'
import type { RowAction } from '../types'

export const SortableTableRowActionButton = ({
  rowAction: { title, onClick, items, isLoading, iconName, disabledText },
}: {
  rowAction: Except<RowAction, 'key'>
}) => {
  const translate = useTranslate()

  const isEnabled = !!(onClick || items)

  const element = (
    <IconButton
      tip={
        isEnabled ? (
          title
        ) : (
          <>
            {title}
            <br />
            {disabledText ?? translate('genericUnavailableAction')}
          </>
        )
      }
      isLoading={isLoading}
      disabled={!isEnabled}
      onClick={
        onClick
          ? (e) => {
              e.stopPropagation()
              onClick()
            }
          : undefined
      }
      iconName={iconName}
    />
  )

  return items ? <Dropdown element={element} items={items} /> : element
}
